import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

import * as SimilarBooksActions from 'rebook/apps/books/actions/SimilarBooksActions';
import BookList from 'rebook/apps/books/components/BookList';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';

import styles from './style.scss';


class SimilarBooksView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    this.props.SimilarBooksActions.fetchInitialData(match, location);
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(SimilarBooksActions.fetchInitialData(match));
  }

  componentWillUnmount() {
    this.props.SimilarBooksActions.resetData();
  }

  render() {
    const { bookList, book } = this.props.similarBooks;

    return bookList
      ? (
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(book, 'main_author.cover_name', ''), url: get(book, 'main_author.absolute_url', '') },
            { text: get(book, 'name', ''), url: get(book, 'absolute_url', '') },
            { text: 'Похожие книги', url: '' },
          ]} />
          <div className="sectionHeader">
            <h1>
              {`Книги, похожие на `}
              <Link to={{
                pathname: book.absolute_url,
                state: { similarBooks: bookList, book },
              }}>
                <span className="link">«{book.name}»</span>
              </Link>
            </h1>
          </div>
          <div className={styles.bookList}>
            <BookList books={bookList} />
          </div>
        </div>
      )
      : (
        <div className="section">
          <BookList books={[...Array(5)]} />
        </div>
      );
  }
}

function mapStateToProps(state) {
  return {
    similarBooks: state.similarBooks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SimilarBooksActions: bindActionCreators(SimilarBooksActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SimilarBooksView);
